export const InfoboxIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			id="eb-info-box"
			viewBox="0 0 64 64"
		>
			<linearGradient
				id="SVGID_1__56360"
				gradientUnits="userSpaceOnUse"
				x1="32"
				y1="19.203"
				x2="32"
				y2="45.242"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#1a6dff" />
				<stop offset="1" stopColor="#c822ff" />
			</linearGradient>
			<polygon
				points="43,19 21,19 21,25 29,25 29,45 35,45 35,25 43,25"
				fill="url(#SVGID_1__56360)"
			/>
			<linearGradient
				id="SVGID_2__56360"
				gradientUnits="userSpaceOnUse"
				x1="32"
				y1="9.359"
				x2="32"
				y2="55.428"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#6dc7ff" />
				<stop offset="1" stopColor="#e6abff" />
			</linearGradient>
			<path
				d="M54,9H10c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h44c2.757,0,5-2.243,5-5V14 C59,11.243,56.757,9,54,9z M57,50c0,1.654-1.346,3-3,3H10c-1.654,0-3-1.346-3-3V14c0-1.654,1.346-3,3-3h44c1.654,0,3,1.346,3,3V50z"
				fill="url(#SVGID_2__56360)"
			/>
			<linearGradient
				id="SVGID_3__56360"
				gradientUnits="userSpaceOnUse"
				x1="58"
				y1="26.939"
				x2="58"
				y2="61.543"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#1a6dff" />
				<stop offset="1" stopColor="#c822ff" />
			</linearGradient>
			<path
				d="M58,28c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S60.206,28,58,28z"
				fill="url(#SVGID_3__56360)"
			/>
			<linearGradient
				id="SVGID_4__56360"
				gradientUnits="userSpaceOnUse"
				x1="58"
				y1="30.125"
				x2="58"
				y2="33.875"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#6dc7ff" />
				<stop offset="1" stopColor="#e6abff" />
			</linearGradient>
			<circle cx="58" cy="32" r="2" fill="url(#SVGID_4__56360)" />
			<linearGradient
				id="SVGID_5__56360"
				gradientUnits="userSpaceOnUse"
				x1="6"
				y1="26.939"
				x2="6"
				y2="61.543"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#1a6dff" />
				<stop offset="1" stopColor="#c822ff" />
			</linearGradient>
			<path
				d="M6,28c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S8.206,28,6,28z"
				fill="url(#SVGID_5__56360)"
			/>
			<linearGradient
				id="SVGID_6__56360"
				gradientUnits="userSpaceOnUse"
				x1="6"
				y1="30.125"
				x2="6"
				y2="33.875"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#6dc7ff" />
				<stop offset="1" stopColor="#e6abff" />
			</linearGradient>
			<circle cx="6" cy="32" r="2" fill="url(#SVGID_6__56360)" />
			<linearGradient
				id="SVGID_7__56360"
				gradientUnits="userSpaceOnUse"
				x1="32"
				y1="21.172"
				x2="32"
				y2="43.205"
				spreadMethod="reflect"
			>
				<stop offset="0" stopColor="#6dc7ff" />
				<stop offset="1" stopColor="#e6abff" />
			</linearGradient>
			<polygon
				points="41,21 23,21 23,23 31,23 31,43 33,43 33,23 41,23"
				fill="url(#SVGID_7__56360)"
			/>
		</svg>
	);
};
